import { LongRunningContextCategoryTyp } from '../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from '../../server-communication/running-actions/types/longRunningAction.decorator';

@LongRunningAction(LongRunningContextCategoryTyp.CONTACT_STATUS)
export class UpdateRegistrationOfContactStates {
   public static readonly type = '[ContactStates] update registration of contact states';

   constructor() {}
}
